class TrackController {
  constructor($rootScope, AuthService, TrackingService, $timeout) {
    this.name = "track";
    this.$rootScope = $rootScope;
    this.$auth = AuthService;
    this.$tracking = TrackingService;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.$timeout = $timeout;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?key=" + this.googleMapKey + "&libraries=places&language=en";
  }
}

TrackController.$inject = ["$rootScope", "auth", "tracking", "$timeout"];

export default TrackController;



// WEBPACK FOOTER //
// ./client/app/common/track/track.controller.js